module.exports = __webpack_public_path__ + "img/Rohit.c22b9ce3.png";